import { TextData } from "interfaces/TextEditor";
import { httpCollection } from "us.helper/http/collection";
import { versionedHttpCollection } from "us.helper/http/collection";

export default {
  text: {
    save: (text: TextData): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationservice",
            "text",
            text
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.deleteWithParams(
            "communicationservice",
            'text',
             params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
